import React, { FC } from 'react';
import * as ReactDOM from 'react-dom';
import { CloseIcon } from 'assets/icons/CloseIcon';
import Button from 'components/shared/Button';
import styles from './ConfirmDialog.module.scss';

interface ActionButton {
  text: string;
  onClick: () => void;
}

interface MultiActionConfirmDialogProps {
  open: boolean;
  title: string;
  description?: string;
  actions: ActionButton[];
  declineBtnText: string;
  onClose: () => void;
  transparentOverlay?: boolean;
}

const MultiActionConfirmDialog: FC<MultiActionConfirmDialogProps> = ({
  open,
  title,
  description,
  actions,
  declineBtnText,
  onClose,
  transparentOverlay,
  }) => {
  const handleAction = (actionFn: () => void) => {
    actionFn();
    onClose();
  };
  
  if (!open) return null;

  return ReactDOM.createPortal(
    <>
      <div
        className={`${styles.overlay} ${
          transparentOverlay ? styles.transparentOverlay : styles.shadowOverlay
        }`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
      <div className={styles.wrapper}>
        <div className={styles.controls}>
          {title && <h2 className={styles.title}>{title}</h2>}
          <button
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Close dialog"
          >
            <CloseIcon />
          </button>
        </div>
        <div className={styles.dialogContainer}>
          {description && <div className={styles.description}>{description}</div>}
          <div className={styles.controller}>
            {declineBtnText && (
              <Button onClick={onClose}>{declineBtnText}</Button>
            )}
            {actions.map((action, index) => (
              <Button
                key={index}
                type="button"
                variant="primary"
                onClick={() => handleAction(action.onClick)}
              >
                {action.text}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </>,
    document.getElementById('confirmation') as HTMLElement
  );
};

export default MultiActionConfirmDialog;